import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Utilities } from "./utilities";

@Injectable()
export class CustomService {

  public action = "edit";

  constructor(
    private afdb: AngularFireDatabase,
    private utilities: Utilities,
  ) { }

  public getCustomList(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Custom`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Custom`;
    }
    return this.afdb.list<any>(ref).valueChanges();
  }

  public getCustomItem(clientId: string, customId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/Custom/${customId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/Custom/${customId}`;
    }
    return this.afdb.object<any>(ref).valueChanges();
  }

  public getConfigCustom(clientId: string, eventId: string = null) {
    let ref = `Clients/${clientId}/Interactivity/ConfigCustom`;
    if (this.utilities.validateEventIdParam(eventId)) {
      ref = `Clients/${clientId}/Event/${eventId}/ConfigCustom`;
    }
    return this.afdb.object<any>(ref).valueChanges();
  }

  public createOrEditCustom(clientId: string, customInfo: any) {
    if (!customInfo.id) {
      customInfo.id = this.utilities.generateRamdomKey();
      this.action = "create";
    }

    let ref = `Clients/${clientId}/Interactivity/Custom/${customInfo.id}`;
    if (this.utilities.validateEventIdParam(customInfo.eventId)) {
      ref = `Clients/${clientId}/Event/${customInfo.eventId}/Custom/${customInfo.id}`;
    }

    return new Promise((res, rej) => {
      this.afdb.database
        .ref(ref)
        .set(customInfo)
        .then(() => {
          return res(customInfo.id);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }
  public saveConfigCustom(clientId: string, customInfo: any) {
    let ref = `Clients/${clientId}/Interactivity/ConfigCustom`;
    if (this.utilities.validateEventIdParam(customInfo.eventId)) {
      ref = `Clients/${clientId}/Event/${customInfo.eventId}/ConfigCustom`;
    }

    return new Promise((res, rej) => {
      this.afdb.database
        .ref(ref)
        .set(customInfo)
        .then(() => {
          return res(customInfo);
        })
        .catch((e) => {
          return rej(e);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/custom.service.ts